import { Core } from 'chessboard/core/config/types';

/**
 * The various events that change game position.
 */
export const positionChangeEvents: string[] = [
  Core.APIEvents.CreateGame,
  Core.APIEvents.CreateContinuation,
  Core.APIEvents.DeletePosition,
  Core.APIEvents.Load,
  Core.APIEvents.Move,
  Core.APIEvents.MoveBackward,
  Core.APIEvents.MoveForward,
  Core.APIEvents.MoveVariation,
  Core.APIEvents.PromoteVariation,
  Core.APIEvents.SelectLineEnd,
  Core.APIEvents.SelectLineStart,
  Core.APIEvents.SelectNode,
  Core.APIEvents.Reload,
  Core.APIEvents.ResetToMainLine,
  Core.APIEvents.Undo,
];
